import React from 'react';
import { TitleBar, Layout, StatusMessage } from '../components/library-components';
import { getMeteringSettings, getNewMeteringSettings } from '../api';
import MeteringRule from '../components/metering_rule/metering_rule';
import _ from 'lodash-es';

const USER_TYPES = ['anonymous', 'logged_in'];

var meterDefaultValues = {
  asset_limit: 5,
  asset_type: 'story',
  duration_value: 2,
  duration_unit: 'days'
};

class PaywallSettings extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      metered: {},
      errors: null,
      showNotification: { isNotificationOpen: false, status: '', statusMessage: '' },
      meteringSettings: []
    };
  }

  componentWillMount () {
    getMeteringSettings().then((meteringSettings) => {
      getNewMeteringSettings().then((initialMeteringSettings) => {
        meteringSettings = USER_TYPES.map((userType) => {
          return _.find(meteringSettings, { user_type: userType }) || Object.assign({}, initialMeteringSettings, { user_type: userType }, meterDefaultValues);
        });
        this.setState({ meteringSettings: meteringSettings });
      });
    });
  }

  filterExistingUserTypes (existingUserTypes) {
    const reducer = (accumulator, currentValue) => {
      if (existingUserTypes.includes(currentValue)) {
        return accumulator;
      } else {
        return accumulator.concat(currentValue);
      }
    };
    return USER_TYPES.reduce(reducer, []);
  }

  updateMeteringSettings (updatedMeteringSetting) {
    const userType = updatedMeteringSetting.user_type;

    const settingsWithoutChanges = this.state.meteringSettings.filter(obj => obj.user_type !== userType)[0];

    const newState = [settingsWithoutChanges, updatedMeteringSetting];

    this.setState({ meteringSettings: newState });
  }

  showStatusMessage (statusMessage) {
    this.setState(
      {
        showNotification: {
          isNotificationOpen: true,
          status: statusMessage.status,
          statusMessage: statusMessage.statusMessage
        }
      });
  }

  render () {
    return <Layout>
      <TitleBar title='Metered Paywall Settings'
        breadcrumbTitle='Home'
        breadcrumbPath='/' />
      { this.state.meteringSettings.length > 0 && USER_TYPES.map((userType) =>
        <MeteringRule
          meteringSetting={_.find(this.state.meteringSettings, { user_type: userType })}
          showStatusMessage={this.showStatusMessage.bind(this)}
          updateMeteringSettings={this.updateMeteringSettings.bind(this)} />) }
      {this.state.showNotification.isNotificationOpen &&
      <StatusMessage statusMessage={this.state.showNotification.statusMessage}
        status={this.state.showNotification.status}
        onCancel={() => this.setState({ showNotification: { isNotificationOpen: false, status: '', statusMessage: '' } })} />}
    </Layout>;
  }
}

export default PaywallSettings;
